import { render, staticRenderFns } from "./AddOrderWithExcel.vue?vue&type=template&id=5bad8ef6"
import script from "./AddOrderWithExcel.vue?vue&type=script&lang=js"
export * from "./AddOrderWithExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports